import {Component, h, Host, Prop} from "@stencil/core";
import {LoaderVariant} from "./loader.enum";

@Component({
    tag: "ux-loader",
    styleUrl: "loader.scss",
    shadow: true
})
export class Loader {

    /**
     * Represents the LoaderVariant property of the component.
     *
     * This property is used to determine the visual style of a loader component.
     * It is an enumeration that can take on one of two values:
     *
     * - `LoaderVariant.Horizontal`: Displays the loader as a horizontal bar.
     * - `LoaderVariant.Spinner`: Displays the loader as a spinning circle.
     *
     * By default, this property is set to `LoaderVariant.Horizontal`.
     */
    @Prop() readonly variant: LoaderVariant = LoaderVariant.Horizontal;

    render() {
        return (
            <Host
                variant={this.variant}
                role='alert'
                aria-busy='true'
            >
            </Host>
        );
    }
}
